const highlights = [
  { icon: 'ri-moon-clear-line', label: 'Miren počitek', value: 'Tiho podeželsko okolje' },
  { icon: 'ri-restaurant-2-line', label: 'Domači zajtrk', value: 'Ob gostilni Marti' },
  { icon: 'ri-car-line', label: 'Parkirni prostor', value: 'Ob objektu' },
];

export default function RoomsIntro() {
  return (
    <section className="relative bg-background-50 py-16 md:py-24 lg:py-28">
      <div className="w-full px-5 md:px-10 lg:px-14">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-16 items-center">
            <div>
              <p className="font-label text-xs tracking-extra-wide text-accent-600 font-medium uppercase mb-3">
                NASTANITEV
              </p>
              <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-light text-foreground-950 mb-5 md:mb-6">
                Prenoči se pri Marti
              </h2>
              <div className="space-y-4 font-body text-sm md:text-base text-foreground-600 leading-relaxed">
                <p>
                  V sklopu Gostilne Marta ponujamo tudi prijetno nastanitev. Na voljo so svetle in
                  udobne sobe, ki so idealne za krajši oddih, poslovno pot ali družinsko potovanje.
                </p>
                <p>
                  Vsaka soba je opremljena z osnovno opremo za sproščeno bivanje, obiskovalce pa
                  pričaka mirno okolje z domačim pridihom. Zaradi bližine gostilne lahko svoj dan
                  zaključiš ob dobrí domači hrani.
                </p>
                <p className="text-foreground-500">
                  Za razpoložljivost, cene in posebne želje nam preprosto pošlji povpraševanje ali
                  nas pokliči.
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-1 gap-4 md:gap-5">
              {highlights.map((item) => (
                <div
                  key={item.label}
                  className="amenity-item flex items-center gap-4 bg-background-100 border border-background-200/70 rounded-lg p-5"
                >
                  <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-500/12 flex-shrink-0">
                    <i className={`${item.icon} text-accent-600 text-xl`}></i>
                  </div>
                  <div>
                    <p className="font-label text-[10px] tracking-extra-wide uppercase text-foreground-500 mb-1">
                      {item.label}
                    </p>
                    <p className="font-body text-sm md:text-base text-foreground-900">{item.value}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}